import React from 'react'
import Navbar from '../../layout/Navbar'
import "./Services.css"

const Dashboard = () => {
  return (
        <div >
      <div id='about-page'>
      <Navbar />
      <div id='about-hero'>
        <h5>SERVICES</h5>
        <h2>WHAT WE <span>PROVIDE</span></h2>
        <p id='about-text'>Explore our comprehensive range of outdoor marketing services at Vwrap, designed to help your brand stand out in the crowd and reach its full potential.</p>
      </div>
    </div>
        
    </div>
  )
}

export default Dashboard
